import { render } from "./Search.vue?vue&type=template&id=2478cd2c&scoped=true&ts=true"
import script from "./Search.vue?vue&type=script&setup=true&lang=ts"
export * from "./Search.vue?vue&type=script&setup=true&lang=ts"

import "./Search.vue?vue&type=style&index=0&id=2478cd2c&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2478cd2c"],['__file',"src/views/message/Search.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2478cd2c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2478cd2c', __exports__)) {
    console.log('reload')
    api.reload('2478cd2c', __exports__)
  }
  
  module.hot.accept("./Search.vue?vue&type=template&id=2478cd2c&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('2478cd2c', render)
  })

}


export default __exports__